import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagPickerComponent } from './tag-picker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeColorDirective } from '../../directives';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ButtonModule,
    MatTooltipModule,
    ThemeColorDirective,
  ],
  declarations: [TagPickerComponent],
  exports: [TagPickerComponent],
})
export class TagPickerModule {}
